import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return {
      division: data.location_division[0].parent,
      locations: data.locations.filter(
        location =>
          location.parent?.level === 'div' &&
          location.parent._id === data.location_division[0].parent._id
      ),
    }
  }, [data])
}
